"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@user/success",
  ERROR: "@@user/error",
  SEND_EMAIL: "@@user/send-email",
  ADD: "@@user/add",
  FETCH: "@@user/fetch",
  DETAILS: "@@user/details",
  LIST: "@@user/list",
  LIST_UNPAGED: "@@user/list-protfolio",
  LIST_TRANSFER: "@@user/list-transfer",
  BRAND_USER_LIST: "@@user/brand-user-list",
  CONTENT_USER_LIST: "@@user/content-user-list",
  APPLICATION_USER_LIST: "@@user/application-user-list",
  DATA_USER_LIST: "@@user/data-user-list",
  REPORT_USER_LIST: "@@user/report-user-list",
  UPDATE: "@@user/update",
  SOFT_DELETE: "@@user/soft-delete",
  HARD_DELETE: "@@user/hard-delete",
  SOFT_RESTORE: "@@user/soft-restore",
  SOFT_DELETE_LIST: "@@user/soft-delete-list",
  UNIQUE_EMAIL: "@@user/unique-email",
  UNIQUE_EMAIL_RESET: "@@user/unique-email-reset",
  BULK_ACTIVATE: "@@user/bulk-deactivate",
  BULK_DEACTIVATE: "@@user/bulk-activate",
  BULK_HARD_DELETE: "@@user/bulk-hard-delete",
  ACTIVITIES: "@@user/activities",
  RESET: "@@user/reset",
  RESET_TRANSFER: "@@user/reset-trasfer",
  AUTHORIZE_DEVICE: "@@user/authorize-device",
  ACTIVATE_USER: "@@user/activate-user",
  DEACTIVATE_USER: "@@user/deactivate-user",
  RESET_PASSWORD_COMMON: "@@user/reset-password-common",
  RESET_PASSWORD_COMMON_RESET: "@@user/reset-password-common-reset",
  TENANT_PERMISSION: "@@user/permission",
  USER_ADMIN: "@@user/admin",
  BULK_SOFT_DELETE: "@@user/bulk-soft-delete",
  BULK_SOFT_DELETE_RESTORE: "@@user/bulk-soft-delete-restore",
  LIST_DELETED_BY_USER: "@@user/list-deleted-by-user"
};
exports.actionTypes = actionTypes;